import { useTranslation } from 'react-i18next';

import { PREDEFINED_RECURSIONS } from 'constants/index';

import Select from 'components/select';

const Option = ({ title, schedule, onClick }) => {
    const handleClick = () => onClick?.({ schedule });

    return (
        <div className="item resource-repeat-row" onClick={handleClick}>
            <span className="row-label">{ title }</span>
        </div>
    );

}

const PredefinedOptions = ({ selected, onSelect }) => {
    const { t } = useTranslation('recurring');


    return (
        <div className="resource-repeat-row large-select">
            <div className="row-label">
                { t('Select') }
            </div>

            <div className="row-value">
                <div className="row-input">
                    <Select
                        small={true}
                        selected={selected}
                        options={PREDEFINED_RECURSIONS.map(item => ({ id: item.id, schedule: item.schedule, text: t(`predefined.${item.id}`) }))}
                        onChange={onSelect}
                    />
                </div>
            </div>
        </div>
    )

    return (
        <div className="predefined-options">
            {
                PREDEFINED_RECURSIONS.map(item => <Option key={item.id} title={ t(`predefined.${item.id}`) } schedule={item.schedule} onClick={onSelect} />)
            }
        </div>
    );
}

export default PredefinedOptions
